export default __webpack_public_path__ + "583c3a1af7fca3f355e6b0a4623cdfde.svg";